export enum BayernIdAttribute {
    Salutation = 'salutation',
    Title = 'title',
    GivenName = 'given_name',
    FamilyName = 'family_name',
    Name = 'name',
    DateOfBirth = 'date_of_birth',
    PlaceOfBirth = 'place_of_birth',
    BirthName = 'birth_name',
    Nationality = 'nationality',
    StreetAndBuilding = 'street_and_building',
    ZipCode = 'zip_code',
    City = 'city',
    CommunityId = 'community_id',
    Country = 'country',
    Email = 'email',
    Telephone = 'telephone',
    BPk2 = 'bPK2',
    LegacyPostkorbHandle = 'legacy_postkorb_handle',
    TrustLevelAuthentication = 'trust_level_authentication',
    DocumentType = 'document_type',
    EIdasIssuingCountry = 'e_idas_issuing_country',
    Pseudonym = 'pseudonym',
    AssertionProvedBy = 'assertion_proved_by',
    ApiVersion = 'api_version',
    ApplicationId = 'application_id',
}

export enum BundIdAttribute {
    Salutation = 'salutation',
    Title = 'title',
    GivenName = 'given_name',
    FamilyName = 'family_name',
    Name = 'name',
    DateOfBirth = 'date_of_birth',
    PlaceOfBirth = 'place_of_birth',
    BirthName = 'birth_name',
    Nationality = 'nationality',
    StreetAndBuilding = 'street_and_building',
    ZipCode = 'zip_code',
    City = 'city',
    CommunityId = 'community_id',
    Country = 'country',
    Email = 'email',
    Telephone = 'telephone',
    BPk2 = 'bPK2',
    LegacyPostkorbHandle = 'legacy_postkorb_handle',
    TrustLevelAuthentication = 'trust_level_authentication',
    DocumentType = 'document_type',
    EIdasIssuingCountry = 'e_idas_issuing_country',
    Pseudonym = 'pseudonym',
    AssertionProvedBy = 'assertion_proved_by',
    ApiVersion = 'api_version',
    ApplicationId = 'application_id',
}

export enum MukAttribute {
    ElsterIdentitaetstyp = 'elster_identitaetstyp',
    OrgCompanyName = 'org_company_name',
    OrgLegalFormText = 'org_legal_form_text',
    OrgLegalFormCode = 'org_legal_form_code',
    OrgOccupationText = 'org_occupation_text',
    OrgOccupationCode = 'org_occupation_code',
    OrgRegisterNumber = 'org_register_number',
    OrgRegisterType = 'org_register_type',
    OrgRegisterCourt = 'org_register_court',
    Salutation = 'salutation',
    Title = 'title',
    GivenName = 'given_name',
    FamilyName = 'family_name',
    Name = 'name',
    ZusatzName = 'zusatz_name',
    DateOfBirth = 'date_of_birth',
    OrgAddressType = 'org_address_type',
    OrgStreet = 'org_street',
    OrgBuilding = 'org_building',
    OrgZipCode = 'org_zip_code',
    OrgCity = 'org_city',
    OrgCityDistrict = 'org_city_district',
    OrgAddressAddition = 'org_address_addition',
    OrgCountry = 'org_country',
    PreferredUsername = 'preferred_username',
    ElsterDatenuebermittler = 'elster_datenuebermittler',
    ElsterDatenkranzTyp = 'elster_datenkranz_typ',
    TrustLevelIdentification = 'trust_level_identification',
    TrustLevelAuthentication = 'trust_level_authentication',
}

export enum ShIdAttribute {
    DataportIdentitaetstyp = 'dataport_identitaetstyp',
    Salutation = 'salutation',
    Title = 'title',
    GivenName = 'given_name',
    FamilyName = 'family_name',
    Name = 'name',
    DateOfBirth = 'date_of_birth',
    PlaceOfBirth = 'place_of_birth',
    BirthName = 'birth_name',
    Gender = 'gender',
    StreetAndBuilding = 'street_and_building',
    ZipCode = 'zip_code',
    City = 'city',
    Country = 'country',
    Email = 'email',
    Telephone = 'telephone',
    Mobilephone = 'mobilephone',
    PreferredLanguage = 'preferred_language',
    OrgCompanyName = 'org_company_name',
    OrgOrganizationUnit = 'org_organization_unit',
    OrgRegisterNumber = 'org_register_number',
    OrgRegisterCourt = 'org_register_court',
    OrgContactMail = 'org_contact_mail',
    OrgContactPhone = 'org_contact_phone',
    OrgStreetAndBuilding = 'org_street_and_building',
    OrgZipCode = 'org_zip_code',
    OrgCity = 'org_city',
    OrgCountry = 'org_country',
    OrgPostboxNumber = 'org_postbox_number',
    OrgPostboxZipCode = 'org_postbox_zip_code',
    OrgPostboxCountry = 'org_postbox_country',
    ElsterDatenuebermittler = 'elster_datenuebermittler',
    TrustLevelAuthentication = 'trust_level_authentication',
    PreferredUsername = 'preferred_username',
    DataportInboxId = 'dataport_inbox_id',
    DataportServicekontoType = 'dataport_servicekonto_type',
}